import { Environment } from "common";
import React, { Component } from "react";

import api from "services/api";
import { eadApi } from "services/ead";

class ReasonsModal extends Component {
  state = {
    reasons: [],
    loading: true,
    selected: null,
  };

  async componentDidMount() {
    const ENABLE_EAD_API = Environment.getEnvBoolean(
      "REACT_APP_ENABLE_EAD_API"
    );

    try {
      const reasons = await (ENABLE_EAD_API
        ? eadApi
            .get("documents/reject-reasons")
            .then((response) => response.data)
        : api.get("user/v2/document_request_reasons?per=100").then((response) =>
            response.data.data.map((r) => ({
              id: r.id,
              title: r.attributes.title,
            }))
          ));

      this.setState({ reasons });
    } finally {
      this.setState({ loading: false });
    }
  }

  handleSelect = (id) => {
    const { selected } = this.state;
    const { onSelect } = this.props;

    this.setState({ selected: selected === id ? null : id });
    onSelect(selected === id ? null : id);
  };

  render() {
    const { reasons, selected } = this.state;

    return (
      <div className="document-reasons">
        {reasons.map((reason) => (
          <button
            key={reason.id}
            className={`reason-checkbox ${
              selected === reason.id ? "selected" : ""
            }`}
            onClick={() => this.handleSelect(reason.id)}
          >
            <span>
              {selected === reason.id && <i className="fa fa-check" />}
            </span>
            {reason.title}
          </button>
        ))}
      </div>
    );
  }
}

export default ReasonsModal;
